import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const formatCost = (value) => `${Number(value || 0).toFixed(2)}\u20AC`

const renderProviderRows = (providers, keyPrefix) =>
  Object.entries(providers || {}).map(([provider, details]) => (
    <li key={`${keyPrefix}-${provider}`}>
      {provider.toUpperCase()}: {formatCost(details.total)}
    </li>
  ))

const GPTEstimateModal = ({ show, onHide, onSubmit, params, isLLMVisibility = false }) => {
  const phaseEstimates = params.phase_estimates || {}

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title className="d-flex justify-content-center align-items-center w-100">
          {isLLMVisibility ? 'Stima dei costi LLM Visibility' : 'Stima dei costi GPT'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center align-items-center flex-column">
        <p>
          Keyword trovate nel file: {params.n_keywords} <br />
          Tokens calcolati: circa {params.total_tokens}
        </p>
        {isLLMVisibility ? (
          <>
            <h4>Il costo stimato del primo run è di {formatCost(params.first_run_estimate)}</h4>
            <p className="mb-2">Costo ricorrente per run successivi: {formatCost(params.estimate)}</p>
            <div className="w-100">
              <strong>Breakdown per fase</strong>
              <ul className="mb-0">
                <li>Generazione domande: {formatCost(phaseEstimates.question_generation?.total)}</li>
                <li>Ottenimento risposte: {formatCost(phaseEstimates.answer_retrieval?.total)}</li>
                {renderProviderRows(phaseEstimates.answer_retrieval?.providers, 'retrieval')}
                <li>Analisi risposte: {formatCost(phaseEstimates.answer_analysis?.total)}</li>
                {renderProviderRows(phaseEstimates.answer_analysis?.providers, 'analysis')}
              </ul>
            </div>
          </>
        ) : (
          <h4>Il costo stimato è di {formatCost(params.estimate)}</h4>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center align-items-center">
        <Button variant="primary" onClick={onSubmit}>
          Ok
        </Button>
        <Button variant="danger" onClick={() => onHide(false)}>
          Chiudi
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default GPTEstimateModal
